import React, { useMemo } from 'react'
import { Avatar } from '@node-space/ui-components'
import { floorWithPrecision } from 'utils/utils'
import { SourcePayWallet } from '../../Pay/types'

interface UseWalletOptionsProps {
  sourceWalletAtom?: SourcePayWallet | null
}

export const useWalletOptions = ({ sourceWalletAtom }: UseWalletOptionsProps) => {
  const walletsOptions = useMemo(() => {
    if (!sourceWalletAtom) {
      return []
    }

    return [
      {
        LeftElement: <Avatar name={sourceWalletAtom?.currency?.toLowerCase() ?? ''} size="small" />,
        value: sourceWalletAtom?.walletId,
        leftText: sourceWalletAtom?.walletName,
        rightText: `${floorWithPrecision(sourceWalletAtom?.balance ?? 0, sourceWalletAtom?.quantityPrecision)} ${sourceWalletAtom?.currency}`,
      },
    ]
  }, [sourceWalletAtom])

  return { walletsOptions }
}
